import * as React from 'react';
import { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Grid, Typography } from '@mui/material';
export default function CategoryDialog({ openDialog, onClose, updateData }: any) {
  // console.log(updateData);
  const [open, setOpen] = React.useState(openDialog);
  const [formData, setFormData] = useState({...updateData});
  const titleMap:any = {
    newCat: {
      title: "Add new Category",
      label: "Category name...",
      btnText: "Submit",
      btnColor: "primary",
    },
    newSubCat: {
      title: "Add new Sub-Category",
      label: "Sub-Category name...",
      btnText: "Submit",
      btnColor: "primary",
    },
    updateCat: {
      title: "Update Category",
      label: "Category name...",
      btnText: "Submit",
      btnColor: "primary",
    },
    updateSubCat: {
      title: "Update Sub-Category",
      label: "Sub-Category name...",
      btnText: "Submit",
      btnColor: "primary",
    },
    removeCat: {
      title: "Category",
      label: "Category name...",
      btnText: "Submit",
      btnColor: "error",
    },
    removeSubCat: {
      title: "Sub-Category",
      label: "Sub-Category name...",
      btnText: "Remove",
      btnColor: "error",
    },
    default: {
      title: "Add Category/Sub-Category",
      label: "Category/Sub-Category name...",
      btnText: "Remove",
      btnColor: "primary",
    }
  };

  const handleClose = (_name: any) => {
    setOpen(false);
    onClose('');
  };

  useEffect(() => {
    setOpen(openDialog);
  }, [openDialog])

  useEffect(() => {
    setFormData({...updateData});
  }, [updateData])

  const handleChange = (event: any) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={(_e) => handleClose('')}
      >
        <DialogTitle>{titleMap[updateData?.type]?.title}</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} padding={2}>
            <Grid item xs={12}>
              {
                (formData?.type !== 'removeCat' && formData?.type !== 'removeSubCat') ? <TextField
                  fullWidth
                  label={titleMap[updateData?.type]?.label}
                  name="updatedValue"
                  value={formData.updatedValue}
                  onChange={handleChange}
                /> : <Typography variant="body1">Do you want to remove <span style={{color: '#fff', fontWeight: 'bold',backgroundColor: 'var(--secondary)', padding: '2px 5px'}}>{updateData?.initialValue}</span> ?</Typography>
              }
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={(_e) => handleClose('')}>Cancel</Button>
          <Button variant="contained" color={titleMap[updateData?.type]?.btnColor} onClick={(_e) => onClose(formData)}>{titleMap[updateData?.type]?.btnText}</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
